import React from 'react';
import { bool, object, string } from 'prop-types';

import MuiTextField from '@material-ui/core/TextField';

import defaultClasses from './TextField.module.css';

/**
 * List of input types to auto-shrink the labels for
 *
 * See also:
 *
 * *  https://v3.material-ui.com/demos/text-fields/#limitations
 */
const ShrinkableLabels = ['date', 'datetime', 'datetime-local', 'number'];


const TextField = ({
    error,
    errors,
    helperText,
    InputLabelProps,
    InputProps,
    shrink,
    touched,
    type,
    ...props
}) => {
    error || (error = touched && Boolean(errors));
    helperText = (touched && errors) || helperText;
    let shrinkLabel = shrink;
    if (shrink !== true && ShrinkableLabels.includes(type)) {
        shrinkLabel = true;
    }
    return (
        <MuiTextField
            error={error}
            FormHelperTextProps={{
                classes: {
                    root: defaultClasses.helperText
                }
            }}
            helperText={helperText}
            InputLabelProps={{
                classes: {
                    disabled: defaultClasses.labelDisabled,
                    error:    defaultClasses.labelError,
                    focused:  defaultClasses.labelFocused,
                    root:     defaultClasses.label,
                    shrink:   defaultClasses.shrink
                },
                shrink: shrinkLabel,
                ...InputLabelProps
            }}
            InputProps={{
                ...InputProps,
                classes: {
                    error: defaultClasses.inputError,
                    root:  defaultClasses.input
                }
            }}
            /* eslint-disable react/jsx-no-duplicate-props */
            /**
            * react/jsx-no-duplicate-props triggers a false negative due to
            * case sensitivity
            */
            inputProps={{
                required: undefined
            }}
            /* eslint-enable react/jsx-no-duplicate-props */
            margin="normal"
            type={type}
            {...props}
        />
    );
};

TextField.defaultProps = {
    error:      false,
    InputProps: {},
    touched:    false
};

TextField.propTypes = {
    error:      bool,
    errors:     string,
    helperText: string,
    InputProps: object,
    shrink:     bool,
    touched:    bool
};

export default TextField;
